import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';

const { useGet: useCourseTableOfContent } = getCRUDHooks({
  entityName: 'courseTableOfContent',
  get: ({ courseId }: { courseId: number }) =>
    clientApi.getOCClient().helpers.learningContent.courses.getTableOfContent(courseId),
});

export default useCourseTableOfContent;
